import { useEffect, useMemo, useState } from 'react';
import { checkDriveAccess } from '../lib/valuebellApi';

export function useDriveFileInfo(user, fileId) {
  const [result, setResult] = useState(null);
  const request = useMemo(() => ({ user, fileId }), [user, fileId]);
  useEffect(() => {
    if (!user || !fileId) return undefined;
    let cancelled = false;
    const timeout = setTimeout(() => {
      cancelled = true;
      setResult({ request, error: 'Checking this Drive file timed out. Please try again.' });
    }, 20000);
    const timer = setTimeout(async () => {
      try {
        const data = await checkDriveAccess(user, fileId);
        if (!cancelled) setResult({ ...data, request });
      } catch (error) {
        if (!cancelled) setResult({ request, error: 'Could not check this Drive file. Check its sharing settings and try again.' });
      } finally { clearTimeout(timeout); }
    }, 400);
    return () => { cancelled = true; clearTimeout(timer); clearTimeout(timeout); };
  }, [user, fileId, request]);
  if (!user || !fileId) return { file: null, loading: false };
  if (result?.request !== request) return { file: null, loading: true };
  return { ...result, loading: false };
}
